"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserMutation = void 0;
const types_1 = require("../../types");
exports.createUserMutation = `
  mutation createUserMutation($input: UserInput!) {
    createUser(UserInput: $input) {
        ...user
    }
  }
  ${types_1.userFragment}
`;
//# sourceMappingURL=user.js.map